import { render, staticRenderFns } from "./discount-vouchers.vue?vue&type=template&id=960c41e2&scoped=true"
import script from "./discount-vouchers.vue?vue&type=script&lang=js"
export * from "./discount-vouchers.vue?vue&type=script&lang=js"
import style0 from "./discount-vouchers.vue?vue&type=style&index=0&id=960c41e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960c41e2",
  null
  
)

export default component.exports